import { SvgIcon, SvgIconProps } from '@mui/material';

export const ArrowUpwardCircle = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
        <circle cx="15.1667" cy="15.1667" r="14.1667" stroke="white" strokeWidth="2" />
        <path d="M15 21L15 9M15 9L20 14.1429M15 9L10 14.1429" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
};
